// Libs
import { ArrowLeftIcon } from "@heroicons/react/24/solid";

export default function EscapeIframeNavButton(props: {
  href: string;
}): JSX.Element {
  return (
    <a
      href={props.href}
      target="_PARENT"
      className="my-2 mr-5 inline-flex max-w-fit items-center justify-start rounded-md border border-gray-300 bg-white text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primaryLight focus:ring-offset-2"
    >
      <ArrowLeftIcon
        aria-label="go back button"
        className="mx-5 my-2 h-8 text-primary"
      />
    </a>
  );
}
